module.exports = __webpack_public_path__ + "static/HSBC-Pictogram-Ribbon-Red-89f52412a92e145bf7b05ae2d667053a.png";